export enum DefaultPhone {
  Home = 'Home',
  Work = 'Work',
  Cell = 'Cell',
}
